import { LocationGate, NavigateGate } from 'models/router-gate';
import { useLocation, useNavigate } from 'react-router-dom';

const RouterGateRoot = () => {
    const navigate = useNavigate();
    const location = useLocation();
    return (
        <>
            <LocationGate {...location} />
            <NavigateGate navigate={navigate} />
        </>
    );
};

export default RouterGateRoot;
